import React, { PropTypes } from 'react';
import { ModalTrigger } from 'common/modal';

const ReserveButton = ({ canReserve }) => (
  canReserve ? <div className="project-participate button-wrapper hide-for-small-only">
    <ModalTrigger className="btn btn-primary" trigger="elite-reservation-modal">
      Request reservation
    </ModalTrigger>
  </div> : null
);

ReserveButton.defaultProps = {
  canReserve: false,
};

ReserveButton.propTypes = {
  canReserve: PropTypes.bool,
};

export default ReserveButton;



// WEBPACK FOOTER //
// ./project/components/reserve_button.jsx